var map = {
	"./AlertNotification/alertNotification.scss": 9897,
	"./CookieConsent/cookie-consent.scss": 3042,
	"./ErrorPage/error-page.scss": 8558,
	"./Footer/footer.scss": 9053,
	"./Form/form.scss": 9107,
	"./Header/header.scss": 6653,
	"./NewsCard/newsCard.scss": 1453,
	"./Preloader/preloader.scss": 333,
	"./SearchForm/search-form.scss": 3338,
	"./SearchResults/search-results.scss": 8494,
	"./Slider/slider.scss": 4649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9201;